import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Sales from './pages/Sales';
import Orders from './pages/Orders';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Customers from './pages/Customers';
import './styles/App.css';

function AppRoutes() {
  const { currentUser, userPermissions, logout } = useAuth();

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/login" 
            element={currentUser ? <Navigate to="/dashboard" /> : <Login />} 
          />
          <Route 
            path="/dashboard" 
            element={currentUser ? <Dashboard user={currentUser} permissions={userPermissions} onLogout={logout} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/inventory" 
            element={currentUser && (currentUser.role === 'admin' || userPermissions?.inventory) ? <Inventory user={currentUser} permissions={userPermissions} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/sales" 
            element={currentUser && (currentUser.role === 'admin' || userPermissions?.sales) ? <Sales user={currentUser} permissions={userPermissions} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/orders" 
            element={currentUser && (currentUser.role === 'admin' || userPermissions?.sales) ? <Orders user={currentUser} permissions={userPermissions} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/customers" 
            element={currentUser && (currentUser.role === 'admin' || userPermissions?.sales) ? <Customers user={currentUser} permissions={userPermissions} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/reports" 
            element={currentUser && (currentUser.role === 'admin' || userPermissions?.reports) ? <Reports user={currentUser} permissions={userPermissions} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/settings" 
            element={currentUser && (currentUser.role === 'admin' || userPermissions?.settings) ? <Settings user={currentUser} permissions={userPermissions} /> : <Navigate to="/login" />} 
          />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;